import { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CameraControls } from '@react-three/drei';
import { CatmullRomCurve3, Vector3 } from 'three';
import * as roadsPath from '../../assets/coordinates/roadsPath.json';
import * as cameraPath from '../../assets/coordinates/cameraPath.json';


const adjustedPoints = roadsPath.truck.map((pos) =>
    new Vector3(parseFloat(pos.x) - 4, parseFloat(pos.y), parseFloat(pos.z) - 59.1)
);
const spline = new CatmullRomCurve3(adjustedPoints);


export default function Cam({ truckPos }) {
    const cameraControlsRef = useRef();
    const location = useLocation();

    const isMobile = window.innerWidth < 768; 
    const screenType = isMobile ? 'mobile' : 'computer'; 

    useEffect(() => {
        const cameraControls = cameraControlsRef.current;
        const currentPath = location.pathname;

        const position = cameraPath[screenType][currentPath]?.position;
        const target = cameraPath[screenType][currentPath]?.target;

        if (cameraControls && position && target && currentPath !== '/captation' && currentPath !== '/charge') {
            cameraControls.setLookAt(...position, ...target, true);
        }

        const cameraControlsDiv = document.querySelector('div[data-camera-controls-version]');
        if (currentPath === '/smartpowering' || currentPath === '/captation' || currentPath === '/charge') {
            cameraControlsDiv.classList.add('none_select');
        } else {
            cameraControlsDiv.classList.remove('none_select');
        }
    }, [location.pathname, isMobile]);

    useEffect(() => {
        const cameraControls = cameraControlsRef.current;
        const currentPath = location.pathname;

        if (cameraControls && (currentPath === '/captation' || currentPath === '/charge')) {
            const truckPosition = spline.getPoint(truckPos);

            const cameraOffsetValues = cameraPath[screenType][currentPath]?.position || [0, 0, 0];
            const targetOffsetValues = cameraPath[screenType][currentPath]?.target || [0, 0, 0];

            const cameraOffset = new Vector3(...cameraOffsetValues);
            const targetOffset = new Vector3(...targetOffsetValues);

            const cameraPosition = truckPosition.clone().add(cameraOffset);
            const targetPosition = truckPosition.clone().add(targetOffset);

            cameraControls.setLookAt(
                cameraPosition.x, cameraPosition.y, cameraPosition.z,
                targetPosition.x, targetPosition.y, targetPosition.z,
                true
            );
        }
    }, [truckPos, location.pathname, isMobile]);

    return (
        <CameraControls
            ref={cameraControlsRef}
            minDistance={20}
            maxDistance={1200}
            enabled={true}
            verticalDragToForward={true}
            dollyToCursor={false}
            infinityDolly={false}
            minZoom={20}
            maxZoom={900}
            smoothTime={2}
            restThreshold={0.1}
            maxPolarAngle={Math.PI / 2.2}
        />
    );
}
